import { Directive } from "@angular/core";

@Directive({ selector: "[mainContainerBody]" })
export class EmcMainContainerBodyDirective {}
